// Los modos usados últimamente, vivos —
// ADR-2026-09-19-la-sidebar-muestra-los-dos-modos-mas-usados.
//
// El registro (y toda la lógica) vive en `lib/modosRecientes`; esto es sólo el puente
// con React: lee la lista y la vuelve a leer cuando cambia. Dos fuentes de cambio:
//
// - `EVENTO_MODO_USADO`, que dispara `registrarModoUsado` en ESTA pestaña. Hace falta
//   porque `localStorage` no avisa nada localmente y la sidebar queda montada mientras
//   el usuario navega de un modo a otro.
// - `storage`, el evento del navegador, que sí llega desde las OTRAS pestañas: con dos
//   abiertas, generar en una no tiene por qué dejar a la otra mostrando una lista vieja.

import { useEffect, useState } from 'react';
import {
  EVENTO_MODO_USADO,
  herramientaDeRuta,
  leerModosRecientes,
  registrarModoUsado,
} from '../lib/modosRecientes';
import { TODAS_LAS_HERRAMIENTAS } from '../pages/estilos/contenidoAtlas';

/** La lista de ids usados, del más reciente al más viejo. */
export function useModosRecientes(): string[] {
  const [recientes, setRecientes] = useState<string[]>(leerModosRecientes);

  useEffect(() => {
    const releer = () => setRecientes(leerModosRecientes());
    window.addEventListener(EVENTO_MODO_USADO, releer);
    window.addEventListener('storage', releer);
    return () => {
      window.removeEventListener(EVENTO_MODO_USADO, releer);
      window.removeEventListener('storage', releer);
    };
  }, []);

  return recientes;
}

/**
 * Anota la herramienta de esta ruta, si es una — el ÚNICO punto de registro.
 *
 * Va en el shell y no en cada modo a propósito: son diez y pico de pantallas, algunas
 * con ruta propia, y todas pasan por acá. Un registro por pantalla se desincroniza
 * solo (un modo nuevo se olvida de anotarse y nunca aparece en la sidebar), y además
 * dejaría afuera las llegadas por link directo.
 *
 * Mira el catálogo COMPLETO y no la lista filtrada de la sidebar: lo que se registra
 * es dónde estuvo el usuario, y eso no depende de su plan ni de su rubro (además, una
 * constante de módulo no puede cambiar de identidad entre renders y disparar el efecto
 * de nuevo — el registro avisa, el aviso re-renderiza, y ahí habría un bucle).
 */
export function useRegistrarModoDeRuta(pathname: string): void {
  useEffect(() => {
    const id = herramientaDeRuta(pathname, TODAS_LAS_HERRAMIENTAS);
    if (id) registrarModoUsado(id);
  }, [pathname]);
}
